<medrecord-auth-confirm-password-form
  [title]="'auth_set_password_title'"
  [description]="'auth_set_password_description'"
  (passwordSubmit)="onSubmit($event)"
></medrecord-auth-confirm-password-form>
